import { APP_ENVIRONMENT, BASE_URL, POS_BASE_URL } from '@/micro/utils/environment'
import { comesFromPOS, getQueryParameterByName, isValidURL } from '@/micro/utils/urls'

export const AGENT_ACCESS_ACTION = 'agent-access'
export const AGENT_ACCESS_PATH = '/user/login/agent-access'

export const isAgentAccessPath = (pathname?: string) => {
  const path = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '')
  return path === AGENT_ACCESS_PATH || path.startsWith(`${AGENT_ACCESS_PATH}/`)
}

/** Solo desvía el flujo cuando el parámetro viene y el ambiente no es sandbox. */
export const isAgentAccessTriggerActive = (location?: string) => {
  if (APP_ENVIRONMENT === 'sandbox') return false
  return getQueryParameterByName('action', location) === AGENT_ACCESS_ACTION
}

/** Misma elección que el arranque con sesión: POS, ?url= o la app. */
export const resolveAuthenticatedHomeUrl = () => {
  const customUrl = getQueryParameterByName('url')

  if (comesFromPOS() || getQueryParameterByName('solution') === 'alegra-pos') {
    return POS_BASE_URL
  }

  if (customUrl) return customUrl

  return BASE_URL
}

export const buildAgentAccessUrl = (destination: string) => {
  const params = new URLSearchParams({ next: destination })
  return `${AGENT_ACCESS_PATH}?${params.toString()}`
}

export const loginPathWithAgentAccess = () => `/user/login?action=${AGENT_ACCESS_ACTION}`

export const resolveAgentAccessDestination = () => {
  const next = getQueryParameterByName('next')

  if (next && isValidURL(next) && !next.includes(AGENT_ACCESS_PATH)) {
    return next
  }

  return resolveAuthenticatedHomeUrl()
}

/** Sin el parámetro, este llamado es el location.replace de siempre. */
export const leaveViaAgentAccess = (destination: string) => {
  if (!isAgentAccessTriggerActive()) {
    location.replace(destination)
    return
  }

  location.replace(buildAgentAccessUrl(destination))
}
